import React, { Fragment } from 'react';
import { Breadcrumbs } from '../../../../AbstractElements';
import CodeOTP from './CodeOTP';

const OTP = () => {
  return (
    <Fragment>
      <Breadcrumbs parent="User" title="User OTP" />
      <CodeOTP />
    </Fragment>
  );
};
export default OTP;